import { render, staticRenderFns } from "./TiptapEditor.vue?vue&type=template&id=7b9e4147&scoped=true&"
import script from "./TiptapEditor.vue?vue&type=script&lang=js&"
export * from "./TiptapEditor.vue?vue&type=script&lang=js&"
import style0 from "./TiptapEditor.vue?vue&type=style&index=0&id=7b9e4147&scoped=true&lang=css&"
import style1 from "./TiptapEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9e4147",
  null
  
)

export default component.exports